import React from 'react';

const EditOutlineIcon = ({ color = '#667085', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M10.8879 2.95614L4.14616 10.092C3.8916 10.363 3.64525 10.8968 3.59598 11.2663L3.29215 13.9269C3.1854 14.8876 3.87517 15.5446 4.82772 15.3803L7.47186 14.9287C7.84139 14.863 8.35872 14.592 8.61328 14.3128L15.355 7.17691C16.5211 5.94517 17.0466 4.54098 15.2318 2.82475C13.4253 1.12494 12.0539 1.72439 10.8879 2.95614Z"
        stroke={color}
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.76562 4.14648C10.1187 6.41289 11.9581 8.14555 14.241 8.37547"
        stroke={color}
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.46094 18.0654H17.2419"
        stroke={color}
        strokeWidth="1.34372"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(EditOutlineIcon);
